import { Opportunity } from "@entities";
import { Box, Button, Stack, TextField } from "@mui/material";
import { type HyperTableFilter } from "@shared/frontend/hyper-table";
import { parseOpportunityAmountRange } from "@shared/helpers/opportunity-amount-range";
import { useState } from "react";

/**
 * Filter opportunities by remaining free seats (amount - approved participants).
 */
export const opportunityAmountRangeFilter: HyperTableFilter<Opportunity> = {
  id: "amountRange",
  icon: "string",
  caption: "מקומות פנויים",
  renderFilter: ({ onSave, meta }) => {
    const [state, setState] = useState({
      minAmount: (meta?.minAmount as string) || "",
      maxAmount: (meta?.maxAmount as string) || "",
    });

    const handleSave = () => {
      const range = parseOpportunityAmountRange(
        state.minAmount,
        state.maxAmount,
      );
      const value =
        range.min == null && range.max == null
          ? {}
          : Opportunity.freeSeatsInRange(range);

      onSave({ value, meta: state });
    };

    return (
      <Stack
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1.5,
          px: 1,
          pt: 0.5,
        }}
      >
        <TextField
          type="number"
          placeholder="מינימום פנויים"
          value={state.minAmount}
          onChange={(e) =>
            setState({
              ...state,
              minAmount: e.target.value,
            })
          }
          inputProps={{ min: 0 }}
          size="small"
        />
        <TextField
          type="number"
          placeholder="מקסימום פנויים"
          value={state.maxAmount}
          onChange={(e) =>
            setState({
              ...state,
              maxAmount: e.target.value,
            })
          }
          inputProps={{ min: 0 }}
          size="small"
        />
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Button variant="contained" color="primary" onClick={handleSave}>
            שמירה
          </Button>
        </Box>
      </Stack>
    );
  },
};
